import { isMotionValue } from "./is-motion-value.mjs";
function resolveMotionValue(value) {
  return isMotionValue(value) ? value.get() : value;
}
export {
  resolveMotionValue
};
